import axios from 'axios';
import i18n from '@/common/i18n/i18n.js';
import { setAxiosCsrfHeader } from '@/utils/requests.js';

const path = require('path');

const DEV_ENV = process.env.NODE_ENV === 'development' ? true : false;
const DEV_USERNAME = process.env.VUE_APP_API_ADMIN_USERNAME;
const DEV_PASSWORD = process.env.VUE_APP_API_ADMIN_PASSWORD;

class ApiClient {
  // API routes
  DASHBOARD_API_PATH = process.env.VUE_APP_DASHBOARD_API_PATH;
  DATASET_API_PATH = process.env.VUE_APP_DATASET_API_PATH;
  GEOSPATIAL_API_PATH = process.env.VUE_APP_GEOSPATIAL_API_PATH;
  FILE_DOWNLOAD_API_APTH = path.join(`${process.env.VUE_APP_RESOURCE_API_PATH}`, 'file-download/');
  FILE_UPLOAD_API_APTH = path.join(process.env.VUE_APP_RESOURCE_API_PATH, 'file-upload/');
  FTP_API_APTH = path.join(process.env.VUE_APP_RESOURCE_API_PATH, 'ftp/');
  HREF_API_APTH = path.join(process.env.VUE_APP_RESOURCE_API_PATH, 'href/');
  INDEXER_API_PATH = process.env.VUE_APP_INDEXER_API_PATH;
  LOGIN_API_PATH = process.env.VUE_APP_USER_LOGIN_API_PATH;
  ORGANISATION_API_PATH = process.env.VUE_APP_ORGANISATION_API_PATH;
  RESOURCE_API_PATH = process.env.VUE_APP_RESOURCE_API_PATH;
  USER_LOGIN_API_PATH = process.env.VUE_APP_USER_LOGIN_API_PATH;
  USERGROUP_API_PATH = process.env.VUE_APP_USERGROUP_API_PATH;

  constructor() {
    this.client = axios.create();

    this.client.interceptors.request.use(
      (config) => {
        if (DEV_ENV) {
          const base64Credentials = btoa(`${DEV_USERNAME}:${DEV_PASSWORD}`);
          config.headers.Authorization = `Basic ${base64Credentials}`;
        }
        if (!DEV_ENV) {
          config.headers['X-CSRFToken'] = setAxiosCsrfHeader();
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  routeContainsDomain(route) {
    try {
      const url = new URL(route);
      return Boolean(url.hostname);
    } catch (error) {
      return false;
    }
  }

  get(route, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.get(url, config);
  }

  post(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.post(url, data, config);
  }

  put(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.put(url, data, config);
  }

  delete(route, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.delete(url, config);
  }

  patch(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        process.env.VUE_APP_DOMAIN
      );
    return this.client.patch(url, data, config);
  }
};

export default ApiClient;